import { RunwayData } from './types';

// Legacy RunwayData format for runwayWindCalculator compatibility
export const cyrCRunways: RunwayData[] = [
  {
    id: 'rwy-0624',
    heading: 40.4,
    oppositeHeading: 220.4,
    length: 1138,
    surface: 'Asphalte',
    name: '06',
    oppositeName: '24',
  },
  {
    id: 'rwy-1230',
    heading: 105.5,
    oppositeHeading: 285.5,
    length: 1855,
    surface: 'Asphalte',
    name: '12',
    oppositeName: '30',
  },
  {
    id: 'rwy-1836',
    heading: 161.2,
    oppositeHeading: 341.2,
    length: 1149,
    surface: 'Asphalte',
    name: '18',
    oppositeName: '36',
  },
];

export interface RunwayThreshold {
  label: string;
  heading: number;
  elevationFt: number;
  lat: number;
  lon: number;
}

export interface CYRCRunway {
  id: string;
  runwayA: string;
  runwayB: string;
  lengthM: number;
  widthM: number;
  surface: string;
  lighted: boolean;
  closed: boolean;
  thresholdA: RunwayThreshold;
  thresholdB: RunwayThreshold;
}

export const CYRC_RUNWAYS: CYRCRunway[] = [
  {
    id: '06/24',
    runwayA: '06',
    runwayB: '24',
    lengthM: 1138,
    widthM: 46,
    surface: 'Asphalte',
    lighted: false,
    closed: false,
    thresholdA: {
      label: '06',
      heading: 40.4,
      elevationFt: 532,
      lat: 48.51940155029297,
      lon: -71.06220245361328,
    },
    thresholdB: {
      label: '24',
      heading: 220.4,
      elevationFt: 541,
      lat: 48.527198791503906,
      lon: -71.05220031738281,
    },
  },
  {
    id: '12/30',
    runwayA: '12',
    runwayB: '30',
    lengthM: 1855,
    widthM: 46,
    surface: 'Asphalte',
    lighted: true,
    closed: false,
    thresholdA: {
      label: '12',
      heading: 105.5,
      elevationFt: 531,
      lat: 48.51898193359375,
      lon: -71.06260681152344,
    },
    thresholdB: {
      label: '30',
      heading: 285.5,
      elevationFt: 543,
      lat: 48.514747619628906,
      lon: -71.03852081298828,
    },
  },
  {
    id: '18/36',
    runwayA: '18',
    runwayB: '36',
    lengthM: 1149,
    widthM: 46,
    surface: 'Asphalte',
    lighted: true,
    closed: false,
    thresholdA: {
      label: '18',
      heading: 161.2,
      elevationFt: 541,
      lat: 48.527198791503906,
      lon: -71.05220031738281,
    },
    thresholdB: {
      label: '36',
      heading: 341.2,
      elevationFt: 538,
      lat: 48.51750183105469,
      lon: -71.04720306396484,
    },
  },
];

export const CYRC_INFO = {
  icao: 'CYRC',
  name: 'Aéroport Chicoutimi / Saint-Honoré',
  province: 'Québec',
  elevation: 541,
  lat: 48.5214,
  lon: -71.0504,
  timezone: 'America/Toronto',
};